import { useRef } from 'react';

const useAnimateScroll = () => {
  const requestRef = useRef();
  let startTime = null;

  const startElementAnimation = (target, diff, duration = 500) => {
    const startPos = target.scrollLeft;
    startAnimationLoop(target, startPos, diff, duration, 'left');
  };

  const startScroll = (target, duration = 500) => {
    const top = target.getBoundingClientRect().top;
    const startPos = window.pageYOffset;
    const diff = top;
    startAnimationLoop(window, startPos, diff, duration);
  };

  const easeOutQuad = function (t) {
    return 1 - (1 - t) * (1 - t);
  };

  const startAnimationLoop = (
    scrollTarget,
    startPos,
    diff,
    duration,
    direction = 'top'
  ) => {
    const loop = function (currentTime) {
      if (!startTime) {
        startTime = currentTime;
      }

      const time = currentTime - startTime;

      const percent = Math.min(time / duration, 1);
      scrollTarget.scrollTo({
        [direction]: startPos + diff * easeOutQuad(percent),
      });

      if (time < duration) {
        requestRef.current = window.requestAnimationFrame(loop);
      } else {
        cancelAnimation();
      }
    };
    requestRef.current = window.requestAnimationFrame(loop);
  };

  const cancelAnimation = () => {
    if (requestRef.current) {
      window.cancelAnimationFrame(requestRef.current);
      requestRef.current = null;
    }
  };

  return { startScroll, cancelAnimation, startElementAnimation };
};

export default useAnimateScroll;
